import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/var/www/host/frontendv2/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/host/frontendv2/src/@layouts/BlankLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/var/www/host/frontendv2/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/host/frontendv2/src/components/theme/index.tsx");
